import React from 'react'
import ControlAttendancesFilter from './ControlAttendancesFilter'
import { Card } from './Card'
import { useGetRequest, useLoad } from '../../../shared/hooks/requests'
import { ADMIN_INFO,
    TENANT_DYNAMIC_ENTITY,
    TENANT_ENTITY_USERS,
    TENANT_UNLICENSED_MTTS } from '../../../shared/utils/urls'
import { useFilter } from '../../../app/contexts/FilterContextProvider'
import { useMessage } from '../../../shared/hooks/message'

function removeEmpty(obj) {
    return Object.fromEntries(
        Object.entries(obj).filter(([v]) => v != null && v !== ''),
    )
}

export function ControlAttendancesTable() {
    const showMessage = useMessage()
    const { controlFilter } = useFilter()
    const { dateFilter } = useFilter()
    const getUser = useLoad({ url: ADMIN_INFO })
    const getMtts = useGetRequest({ url: TENANT_UNLICENSED_MTTS })
    const getDynamicFirst = useGetRequest({ url: TENANT_DYNAMIC_ENTITY })
    const getDynamicSecond = useGetRequest({ url: TENANT_DYNAMIC_ENTITY })
    const mtts = getMtts.response ? getMtts.response : []
    const firstCard = getDynamicFirst.response ? getDynamicFirst.response?.totalCount : []
    const secondCard = getDynamicSecond.response ? getDynamicSecond.response?.totalCount : []
    const user = getUser.response ? getUser.response : {}

    const handleSearchClick = () => {
        const baseParams = removeEmpty({
            startDate: dateFilter.startPeriod,
            endDate: dateFilter.endPeriod,
            ...(controlFilter.region !== '' ? { region_id: controlFilter.region } : {}),
            ...(controlFilter.district !== '' ? { district_id: controlFilter.district } : {}),
            ...(controlFilter.mttid !== '' ? { mtt_id: controlFilter.mttid } : {}),
        })

        const hasValidFilter = Object.values(baseParams).some((v) => v !== '' && v !== null && v !== undefined)

        if (hasValidFilter && dateFilter.startPeriod && dateFilter.endPeriod) {
            // First request: unspoofed true
            getDynamicFirst.request({
                url: TENANT_DYNAMIC_ENTITY,
                params: { ...baseParams, unspoofed: true },
            })

            // Second request: unspoofed false
            getDynamicSecond.request({
                url: TENANT_DYNAMIC_ENTITY,
                params: { ...baseParams, unspoofed: false },
            })
            getMtts.request()
        } else {
            showMessage('Iltimos malumotni olish uchun sana kiriting', 'success-msg')
        }
    }

    return (
        <div className="w-full h-full flex flex-col items-center gap-[20px]">
            <ControlAttendancesFilter handleSearchClick={handleSearchClick} />
            <div className="w-full flex flex-col items-center gap-[30px]">
                <Card
                    loading={getDynamicFirst.loading}
                    title="Spoofingdan o’tmaganlar soni"
                    count={firstCard}
                    btntitle="qayta spoofingdan o’tkazish"
                />
                <Card
                    loading={getDynamicSecond.loading}
                    title="Jami davomatlar soni"
                    count={secondCard}
                    btntitle="nodavlat-bogcha ga yuborish"
                />
                {user?.tenantId === 18 && (
                    <Card
                        url={TENANT_ENTITY_USERS}
                        loading={getMtts.loading}
                        title="Litsenziyasiz mtt lar soni"
                        count={mtts?.length}
                        btntitle="Xabarnoma yuborish"
                        ids={mtts}
                    />
                )}
            </div>
        </div>
    )
}
